export default __webpack_public_path__ + "static/media/counter_lg.6b1d6014.jpg";